module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "149",
      "height": "49",
      "viewBox": "0 0 149 49",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M67.7044 36.295C67.7065 36.6463 67.6383 36.9944 67.5037 37.3188C67.3691 37.6432 67.1709 37.9372 66.9208 38.1836C66.6707 38.4301 66.3737 38.6238 66.0475 38.7534C65.7213 38.883 65.3724 38.9458 65.0215 38.9382C63.843 38.9382 62.9487 38.2472 62.4205 36.986L61.2837 34.2208H49.9514L48.8131 36.986C48.325 38.2472 47.4323 38.9382 46.2538 38.9382C44.7092 38.9382 43.5308 37.7588 43.5308 36.295C43.558 35.7927 43.6676 35.2981 43.8551 34.8313L53.0405 12.9925C53.527 11.7714 54.4213 11.1284 55.6415 11.1284C56.8617 11.1284 57.7544 11.7791 58.2425 13.0002L67.3847 34.839C67.5891 35.2975 67.6979 35.793 67.7044 36.295ZM51.74 29.7074H59.4627L55.6415 19.2138L51.74 29.7074Z",
      "fill": "#060920"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M76.3339 13.928V36.1332C76.3339 37.719 75.1538 38.9386 73.6108 38.9386C72.0261 38.9386 70.8477 37.719 70.8477 36.1332V13.928C70.8477 12.3422 71.9844 11.1211 73.6108 11.1211C75.1538 11.1288 76.3339 12.3422 76.3339 13.928ZM93.1169 36.3403C93.1169 37.7236 91.9384 38.9432 90.556 38.9432C89.7436 38.9432 88.9713 38.5367 88.3628 37.804L78.1688 26.0569C77.7149 25.5495 77.454 24.8983 77.432 24.2176C77.432 23.5993 77.7162 22.9965 78.2043 22.4679L87.8762 12.016C88.4863 11.407 89.0547 11.1211 89.8671 11.1211C91.2078 11.1211 92.3384 12.2603 92.3384 13.6838C92.3384 14.3345 92.0944 14.9034 91.526 15.5139L83.4388 24.2578L92.4187 34.6694C92.913 35.2413 93.1169 35.7668 93.1169 36.3356V36.3403Z",
      "fill": "#060920"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M102.362 13.9285V36.1336C102.362 37.7195 101.182 38.939 99.6392 38.939C98.0545 38.939 96.876 37.7195 96.876 36.1336V13.9285C96.876 12.3427 98.0128 11.1216 99.6392 11.1216C101.182 11.1293 102.362 12.3427 102.362 13.9285ZM119.145 36.3408C119.145 37.7241 117.967 38.9437 116.584 38.9437C115.772 38.9437 115 38.5372 114.391 37.8045L104.197 26.0574C103.746 25.552 103.487 24.9043 103.465 24.2273C103.465 23.6091 103.749 23.0063 104.237 22.4776L113.909 12.0258C114.527 11.4168 115.088 11.1309 115.9 11.1309C117.242 11.1309 118.371 12.27 118.371 13.6936C118.371 14.3443 118.127 14.9131 117.559 15.5237L109.472 24.2675L118.453 34.6792C118.943 35.2418 119.145 35.7673 119.145 36.3361V36.3408Z",
      "fill": "#060920"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M148.999 25.0312C148.999 32.7982 142.699 38.9422 134.693 38.9422C126.688 38.9422 120.47 32.843 120.47 25.0312C120.47 17.2193 126.728 11.1201 134.693 11.1201C142.699 11.1294 148.999 17.2626 148.999 25.0312ZM126.118 25.0312C126.118 30.1953 129.695 33.8508 134.737 33.8508C139.736 33.8508 143.352 30.1504 143.352 25.0265C143.352 19.9026 139.736 16.2007 134.737 16.2007C129.695 16.2054 126.118 19.8655 126.118 25.0312Z",
      "fill": "#060920"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24.3959 21.6426H10.875V27.0555H24.3959V21.6426Z",
      "fill": "#F5103B"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "opacity": "0.3",
      "d": "M13.5898 27.054V21.6426H14.9444L13.5898 27.054Z",
      "fill": "#5C0617"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "opacity": "0.3",
      "d": "M21.6988 27.054V21.6426H20.3442L21.6988 27.054Z",
      "fill": "#5C0617"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M27.103 17.5819V31.6676C27.1033 31.9101 27.0395 32.1484 26.9179 32.3583C26.7964 32.5681 26.6215 32.7421 26.4111 32.8624L22.3953 35.1592C22.3244 35.2013 22.2435 35.2237 22.1611 35.2241C22.0786 35.2245 21.9976 35.2029 21.9262 35.1614C21.8549 35.12 21.796 35.0603 21.7554 34.9884C21.7149 34.9166 21.6942 34.8352 21.6956 34.7527V17.5819C21.6969 16.5243 21.2856 15.5081 20.5495 14.7494C19.8133 13.9907 18.8103 13.5495 17.754 13.5197C16.6976 13.4899 15.6714 13.8738 14.8937 14.5898C14.1159 15.3057 13.6481 16.2972 13.5898 17.3531C13.5898 17.2975 13.5898 17.2418 13.5898 17.1862C13.5971 17.0769 13.6063 16.9672 13.6176 16.8569C13.6176 16.8028 13.63 16.7487 13.6362 16.6946L13.6593 16.5401C13.6686 16.486 13.6763 16.4334 13.6856 16.3855C13.7057 16.2804 13.7273 16.1738 13.7505 16.0686C13.7628 16.0176 13.7767 15.9651 13.7891 15.9141C13.8014 15.8631 13.8153 15.8105 13.8308 15.7595C13.8462 15.7085 13.8601 15.6529 13.8787 15.6049C13.8972 15.557 13.908 15.5076 13.9235 15.4612C14.0021 15.2242 14.0944 14.9919 14.1999 14.7656C14.2169 14.7255 14.237 14.6837 14.2571 14.6451C14.2772 14.6064 14.2756 14.6049 14.2864 14.5848C14.3096 14.5384 14.3343 14.4921 14.3575 14.4441C14.4881 14.1999 14.6331 13.9635 14.7915 13.7362C14.8378 13.6682 14.8857 13.6018 14.9336 13.5368C15.1229 13.2839 15.3293 13.0443 15.5514 12.8196C16.4758 11.8944 17.6485 11.2572 18.9274 10.9854C20.2063 10.7136 21.5365 10.8189 22.7568 11.2884C23.9771 11.7579 25.0352 12.5716 25.8028 13.6307C26.5704 14.6899 27.0145 15.9491 27.0814 17.2557C27.1015 17.35 27.103 17.4659 27.103 17.5819Z",
      "fill": "url(#paint0_linear_1789_963)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M27.0934 17.2353C27.0265 15.9287 26.5824 14.6695 25.8148 13.6103C25.0472 12.5512 23.9891 11.7375 22.7688 11.268C21.5485 10.7985 20.2183 10.6933 18.9394 10.965C17.6605 11.2368 16.4878 11.874 15.5634 12.7993C15.3413 13.0239 15.1349 13.2635 14.9456 13.5165C14.8977 13.5814 14.8498 13.6478 14.8035 13.7158C14.6451 13.9431 14.5001 14.1795 14.3695 14.4238C14.3463 14.4717 14.3216 14.518 14.2984 14.5644C14.2876 14.5845 14.2784 14.6046 14.2691 14.6247L14.2413 14.6819C14.1271 14.9255 14.0266 15.1752 13.9401 15.43C13.9216 15.481 13.9046 15.5336 13.8907 15.5846C13.8768 15.6356 13.8567 15.6928 13.8428 15.7391C13.8289 15.7855 13.8134 15.8427 13.8011 15.8937C13.7887 15.9447 13.7733 15.9988 13.7625 16.0483C13.7378 16.1518 13.7161 16.2585 13.6976 16.3651C13.6868 16.4192 13.6775 16.4718 13.6714 16.5197C13.6652 16.5676 13.6544 16.6263 13.6482 16.6743C13.642 16.7222 13.6327 16.7825 13.6296 16.8366C13.6157 16.9447 13.608 17.0545 13.6018 17.1658C13.6018 17.2353 13.5941 17.3033 13.5926 17.3744C13.5926 17.3914 13.5926 17.41 13.5926 17.4285C13.5926 17.4734 13.5926 17.5182 13.5926 17.5615V34.7524C13.5939 34.8349 13.5733 34.9163 13.5327 34.9881C13.4922 35.06 13.4332 35.1197 13.3619 35.1611C13.2906 35.2026 13.2096 35.2242 13.1271 35.2238C13.0447 35.2234 12.9638 35.201 12.8929 35.1589L8.87709 32.8621C8.66625 32.7421 8.49098 32.5683 8.36915 32.3584C8.24732 32.1485 8.18329 31.91 8.18359 31.6673V17.7562C8.18359 12.5009 12.4728 8.08032 17.7165 8.11742C20.154 8.13375 22.491 9.09142 24.2399 10.7906C25.9887 12.4898 27.0143 14.7992 27.1027 17.2369L27.0934 17.2353Z",
      "fill": "url(#paint1_linear_1789_963)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M17.6279 43.2786V48.3793C17.2834 48.3797 16.9445 48.293 16.6424 48.1274L13.8932 46.557L5.4059 41.702L1.26498 39.3341C0.880371 39.114 0.560768 38.7961 0.338604 38.4125C0.11644 38.0289 -0.00037923 37.5934 9.24868e-07 37.15V10.8195C9.24868e-07 9.38474 0.56955 8.00872 1.58335 6.99418C2.59715 5.97963 3.97216 5.40967 5.4059 5.40967V36.2922L17.6279 43.2786Z",
      "fill": "#F5103B"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M1.58335 6.9849C0.569549 7.99944 0 9.37546 0 10.8102H5.4059V5.40039C3.97216 5.40039 2.59715 5.97035 1.58335 6.9849Z",
      "fill": "url(#paint2_linear_1789_963)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M35.1378 5.40985V37.2182C35.1385 37.6613 35.0223 38.0967 34.801 38.4804C34.5797 38.8642 34.2611 39.1827 33.8775 39.4038L29.7366 41.7687L22.8124 45.7302L18.6174 48.126C18.3147 48.293 17.9745 48.3802 17.6289 48.3795V43.2788L29.7319 36.3573V4.57364C29.5327 3.29927 28.885 2.13807 27.9057 1.29945C26.9264 0.460829 25.6798 -2.37122e-05 24.3909 9.15068e-10H29.7319C31.1657 9.15069e-10 32.5407 0.569964 33.5545 1.58451C34.5683 2.59905 35.1378 3.97507 35.1378 5.40985Z",
      "fill": "#F5103B"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M18.6057 48.1104L22.8007 45.7146V40.2988L17.6172 43.2632V48.3639C17.9628 48.3645 18.303 48.2773 18.6057 48.1104Z",
      "fill": "url(#paint3_linear_1789_963)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M29.7324 4.57438V5.41213H5.4059C3.97216 5.41213 2.59715 5.98209 1.58335 6.99664C0.569548 8.01118 0 9.3872 0 10.822V5.41213C0.000194392 5.13636 0.0208453 4.86099 0.0617819 4.58829C0.0756828 4.49864 0.0926724 4.40899 0.109662 4.32088C0.163529 4.05819 0.236839 3.79987 0.328988 3.54805C0.358334 3.46613 0.390769 3.38421 0.424749 3.30383C0.976737 2.00895 2.00865 0.978494 3.30378 0.428885C3.38255 0.39488 3.45823 0.362421 3.54781 0.333053C3.79961 0.241366 4.05771 0.168013 4.32008 0.113568C4.40812 0.0965659 4.4977 0.0811087 4.58574 0.0671976C4.85825 0.0262311 5.13342 0.00556569 5.40899 0.00537116H24.3914C25.6797 0.00517409 26.9256 0.465372 27.9049 1.30306C28.8841 2.14075 29.5322 3.30085 29.7324 4.57438Z",
      "fill": "url(#paint4_linear_1789_963)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M29.729 5.40095V4.56404C29.5323 3.15929 28.7219 1.97592 27.7414 1.13907C26.7608 0.30223 25.5131 -0.000196873 24.2231 0V5.40095H29.729Z",
      "fill": "url(#paint5_linear_1789_963)"
    }
  }), _vm._v(" "), _c('defs', [_c('linearGradient', {
    attrs: {
      "id": "paint0_linear_1789_963",
      "x1": "19.5641",
      "y1": "21.5295",
      "x2": "9.95041",
      "y2": "15.9078",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#F5103B"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#7B081E"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint1_linear_1789_963",
      "x1": "3222.92",
      "y1": "7039.85",
      "x2": "3169.35",
      "y2": "8762.98",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#F5103B"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#7B081E"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint2_linear_1789_963",
      "x1": "4.40466",
      "y1": "5.40039",
      "x2": "2.76096",
      "y2": "12.7665",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#B80B2C"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.7817",
      "stop-color": "#F5103B"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint3_linear_1789_963",
      "x1": "17.6172",
      "y1": "45.9489",
      "x2": "24.0765",
      "y2": "43.5384",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#B80B2C"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.7817",
      "stop-color": "#F5103B"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint4_linear_1789_963",
      "x1": "6387.42",
      "y1": "982.37",
      "x2": "8777.19",
      "y2": "832.502",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#F5103B"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#7B081E"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint5_linear_1789_963",
      "x1": "28.9162",
      "y1": "1.8746",
      "x2": "23.7512",
      "y2": "4.66684",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#B80B2C"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.743839",
      "stop-color": "#F5103B"
    }
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3abd6ab5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/icons/AkkoLogo.vue
// module id = 626
// module chunks = 0